module.exports = __webpack_public_path__ + "static/media/vocab_icon.17428676.png";